exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bigDescription{display:block;text-align:center;color:#fff;margin:30vh 9.6vh 0;font-size:3.6vh;letter-spacing:.1vh}@media only screen and (min-width:1024px) and (orientation:landscape){section.newHero{background-image:url(/new/img/backgrounds/app.buddy-1@1.jpg)!important}}@media only screen and (max-width:1024px){section.newHero{background-image:url(/new/img/backgrounds/m-app.buddy-1@1.jpg)!important}}", ""]);

// exports
